import { render } from "./MailAddressChangeCompletePage.vue?vue&type=template&id=1e7ba149"
import script from "./MailAddressChangeCompletePage.vue?vue&type=script&lang=ts"
export * from "./MailAddressChangeCompletePage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1e7ba149"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e7ba149', script)) {
    api.reload('1e7ba149', script)
  }
  
  module.hot.accept("./MailAddressChangeCompletePage.vue?vue&type=template&id=1e7ba149", () => {
    api.rerender('1e7ba149', render)
  })

}

script.__file = "src/views/mailAddressChange/MailAddressChangeCompletePage.vue"

export default script